import React, { useCallback, useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import '../../pages/styles/DoubleRangeSlider.css';

const DoubleRangeSlider = ({ min, max, value, onChange, resetTrigger }) => {
  const [minVal, setMinVal] = useState(value?.min ?? min);
  const [maxVal, setMaxVal] = useState(value?.max ?? max);
  const minValRef = useRef(value?.min ?? min);
  const maxValRef = useRef(value?.max ?? max);
  const range = useRef(null);

  console.log('[Filters]:', value, minVal, maxVal);

  // Convert to percentage
  const getPercent = useCallback((value) => Math.round(((value - min) / (max - min)) * 100), [min, max]);

  // Set width of the range to decrease from the left side
  useEffect(() => {
    const minPercent = getPercent(minVal);
    const maxPercent = getPercent(maxValRef.current);

    if (range.current) {
      range.current.style.left = `${minPercent}%`;
      range.current.style.width = `${maxPercent - minPercent}%`;
    }
  }, [minVal, getPercent]);

  // Set width of the range to decrease from the right side
  useEffect(() => {
    const minPercent = getPercent(minValRef.current);
    const maxPercent = getPercent(maxVal);

    if (range.current) {
      range.current.style.width = `${maxPercent - minPercent}%`;
    }
  }, [maxVal, getPercent]);

  // **useEffect для синхронизации с внешним value**
  useEffect(() => {
    if (!value) return;
     console.log('[Filters] DoubleRangeSlider');

    if (value.min !== minVal) {
      setMinVal(value.min);
      minValRef.current = value.min;
    }

    if (value.max !== maxVal) {
      setMaxVal(value.max);
      maxValRef.current = value.max;
    }
  }, [value, minVal, maxVal]);

  // **useEffect для сброса**
  useEffect(() => {
    if (resetTrigger !== undefined) {
      setMinVal(min);
      setMaxVal(max);
      minValRef.current = min;
      maxValRef.current = max;
    }
  }, [resetTrigger, min, max]);

  return (
    <div className="container">
      <input
        type="range"
        min={min}
        max={max}
        value={minVal}
        onChange={(event) => {
          const value = Math.min(Number(event.target.value), maxVal - 1);

          setMinVal(value);
          minValRef.current = value;

          onChange({
            min: value,
            max: maxValRef.current
          });
        }}
        className="thumb thumb--left"
        style={{ zIndex: minVal > max - 100 && '5' }}
      />
      <input
        type="range"
        min={min}
        max={max}
        value={maxVal}
        onChange={(event) => {
          const value = Math.max(Number(event.target.value), minVal + 1);
          setMaxVal(value);
          maxValRef.current = value;

          onChange({
            min: minValRef.current,
            max: value
          });
        }}
        className="thumb thumb--right"
      />

      <div className="slider">
        <div className="slider__track" />
        <div ref={range} className="slider__range" />
        <div className="slider__left-value">{minVal}</div>
        <div className="slider__right-value">{maxVal}</div>
      </div>
    </div>
  );
};

DoubleRangeSlider.propTypes = {
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  value: PropTypes.shape({
    min: PropTypes.number,
    max: PropTypes.number
  }),
  onChange: PropTypes.func.isRequired,
  resetTrigger: PropTypes.any // Новый проп для сброса
};

export default DoubleRangeSlider;
